import React from "react";
import { cn } from "@/lib/utils";

/**
 * Photorealistic image with blended, vanishing edges (no hard cut).
 * variant: "soft" | "strong" | "bottom" | "none"
 */
export default function SoftImage({ src, alt = "", className, imgClassName, variant = "soft", rounded = true, ...rest }) {
  const maskCls =
    variant === "strong" ? "soft-img-strong" : variant === "bottom" ? "soft-fade-bottom" : variant === "none" ? "" : "soft-img";
  return (
    <div className={cn("relative overflow-hidden", className)} {...rest}>
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={cn("h-full w-full object-cover", rounded && "rounded-[20px]", maskCls, imgClassName)}
      />
    </div>
  );
}
